module.exports = __webpack_public_path__ + "static/img/12594.8aeea72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/12594.jpg
// module id = JJjq
// module chunks = 1